<template>
	<div class="Mine">
		<div class="flex">

			<div class="back-btn" @click="back">
				<img src="../assets/img/back.png" />
				<span>返回</span>
			</div>
			<img @click="goMine()" class="mine-btn" src="../assets/img/home/mine-btn.png" />
		</div>
		<div>
			<img class="title" src="" />

			<div class="lottery-box">
				<div class="lottery-item" :class="active%8==0?'item-white':'item'" @click="showAlertAction(0)">
					<img src="../assets/img/lottery/0.png">
					<div class="name">{{awardList[0].name}}</div>
				</div>
				<div class="lottery-item" :class="active%8==1?'item-white':'item'" @click="showAlertAction(1)">
					<img src="../assets/img/lottery/1.png">
					<div class="name">{{awardList[1].name}}</div>
				</div>
				<div class="lottery-item" :class="active%8==2?'item-white':'item'" @click="showAlertAction(2)">
					<img src="../assets/img/lottery/2.png">
					<div class="name">{{awardList[2].name}}</div>
				</div>
				<div class="lottery-item" :class="active%8==7?'item-white':'item'" @click="showAlertAction(7)">
					<img src="../assets/img/lottery/7.png">
					<div class="name">{{awardList[7].name}}</div>
				</div>
				<div class="lottery-item" @click="randomAward">
					<img style="width: 60%;" src="../assets/img/lottery/lottery-btn.png">
				</div>
				<div class="lottery-item" :class="active%8==3?'item-white':'item'" @click="showAlertAction(3)">
					<img src="../assets/img/lottery/3.png">
					<div class="name">{{awardList[3].name}}</div>
				</div>
				<div class="lottery-item" :class="active%8==6?'item-white':'item'" @click="showAlertAction(6)">
					<img src="../assets/img/lottery/6.png">
					<div class="name">{{awardList[6].name}}</div>
				</div>
				<div class="lottery-item" :class="active%8==5?'item-white':'item'" @click="showAlertAction(5)">
					<img src="../assets/img/lottery/5.png">
					<div class="name">{{awardList[5].name}}</div>
				</div>
				<div class="lottery-item" :class="active%8==4?'item-white':'item'" @click="showAlertAction(4)">
					<img src="../assets/img/lottery/4.png">
					<div class="name">{{awardList[4].name}}</div>
				</div>

			</div>

			<span class="tip">点击礼品可查看详情</span>

			<span class="tip title2">今日可抽奖 {{lotteryNum}} 次</span>
			<br /><br />
			<div class="rule-blank">
				<div class="rule-title">抽奖规则：</div>
				<!-- 				<div>1.每名用户每日成功签到一次，可获得1次抽奖机会；</div>
				<div>2.首次输入手机号验证登陆后，可获得5次抽奖机会；</div>
				<div>3.首次分享捏脸海报后，可获得1次抽奖机会；</div>
				<div>4.02月09日开启预下载，预下载当天，成功签到后，可额外获得5次抽奖机会；零点之前完成手游安装，可额外获得20次抽奖机会；</div>
				<div>5.02月10日公测当天抽奖截止</div>
				<div>6.关注官方微博，可额外获得5次抽奖机会；<a href="javascript:void(0)"
						@click="goWeb(6,'https://weibo.com/u/7504945006')">立即前往</a></div>
				<div>7.关注官方公众号，可额外获得5次抽奖机会；<a href="javascript:void(0)"
						@click="goWeb(7,'https://mp.weixin.qq.com/s?__biz=MzkzNjExMzYyOQ==&mid=2247484521&idx=1&sn=180a5ae086f51105a86a03398f9e9fba&chksm=c2a2e0dbf5d569cdc270b78de117fea533d5d9602f651eb2354ac09eb341760a6895189b766d&token=673939167&lang=zh_CN#rd')">立即前往</a>
				</div>
				<div>6.游戏公测后，使用同一手机号在本APP内下载登陆游戏服务器，可在“个人中心”领取游戏礼包奖励</div>
				<div>
					7.奖品分为游戏礼包奖励与实物奖励；实物奖励中奖后，用户可在个人中心中查看奖励并填写个人信息，游戏公测时使用同一手机号在本APP内下载登陆游戏服务器后安排发货。用户未在限定时间内填写个人收货信息，则视为主动放弃实物奖励；
				</div>
				<div>8.本次活动最终解释权归《我的门派》手游官方所有。</div> -->

				1. 每名用户每日成功签到一次，可获得1次抽奖机会；
				<br />2. 首次输入手机号验证登陆后，可获得5次抽奖机会；
				<br />3. 修容阁每日分享成功后可额外获得1次抽奖机会；
				<br />4. 2月9日 18:00点开启预下载，预下载当天，成功签到后，可额外获得5次抽奖机会；
				<br />5. 2月10日公测当天，成功签到后，可额外获得5次抽奖机会；
				<br />6. 2月11日零点之前完成手游安装并注册，可额外获得20次抽奖机会
				<br />7. 奖品分为游戏礼包奖励与实物奖励；
				<br />8. 游戏公测后，使用同一手机号在本APP内下载登陆游戏服务器，可在“个人中心”领取游戏礼包奖励；
				<br />9.
				实物奖励中奖后，用户可在个人中心中查看奖励并填写个人信息，游戏公测时使用同一手机号在本APP内下载登陆游戏服务器后安排发货。用户未在限定时间内填写个人收货信息，则视为主动放弃实物奖励；
				<br />10. 本次活动解释权归《我的门派》手游官方所有。
			</div>
		</div>
		<br /><br />
		<alert v-if="showAlert" :itemData="itemData" @close="showAlert=false"></alert>
	</div>
</template>

<script>
	import alert from '@/components/lottery/alert.vue'
	export default {
		name: "mine",
		components: {
			alert
		},
		data() {
			return {
				lotteryLoading: false,
				lotteryNum: 0,
				showAlert: false,
				active: 0,
				awardList: [{
					name: '灵石*20',
					url: require('@/assets/img/lottery/0.png'),
					mark: '可获得灵石*20'
				}, {
					name: '门派鼠标垫*1',
					url: require('@/assets/img/lottery/1.png'),
					mark: '可获得门派鼠标垫*1'
				}, {
					name: '灵石*50',
					url: require('@/assets/img/lottery/2.png'),
					mark: '可获得灵石*50'
				}, {
					name: '广招道友*1',
					url: require('@/assets/img/lottery/3.png'),
					mark: '可获得广招道友*1'
				}, {
					name: '门派钥匙扣*1+立牌*1',
					url: require('@/assets/img/lottery/4.png'),
					mark: '可获得门派钥匙扣*1+立牌*1'
				}, {
					name: '加速符*1',
					url: require('@/assets/img/lottery/5.png'),
					mark: '可获得加速符*1'
				}, {
					name: '门派大抱枕*1',
					url: require('@/assets/img/lottery/6.png'),
					mark: '可获得门派大抱枕*1'
				}, {
					name: '仙晶*100',
					url: require('@/assets/img/lottery/7.png'),
					mark: '可获得仙晶*100'
				}, ],
				itemData: {
					name: '灵石*20',
					url: require('@/assets/img/lottery/0.png'),
					mark: '可获得灵石*20'
				}
			};
		},
		async created() {
			this.getLotteryLeftNum()
		},
		watch: {
			accessToken(cv) {
				if (cv) {
					this.getLotteryLeftNum()
				}
				localStorage.setItem('accessToken', cv)
			}
		},
		computed: {
			accessToken() {
				return this.$store.getters.accessToken
			}
		},
		methods: {
			async getLotteryLeftNum() {
				let res = await this.$store.dispatch('getLotteryLeftNum', {})
				if (this.$Api.ok(res)) {
					this.lotteryNum = res[0].data.data.lotteryNum
				}
			},
			async randomAward() {
				if (!this.lotteryNum) {
					this.$Toast.show('暂无抽奖次数')
					return
				}
				if (this.lotteryLoading) {
					//this.$Confirm.show('正在抽奖', async () => {})
					return
				}

				let confirm = async () => {
					this.lotteryLoading = true
					let res = await this.$store.dispatch('randomAward', {})
					if (this.$Api.ok(res)) {


						this.getLotteryLeftNum()
						let index = this.awardList.findIndex(item => item.name == res[0].data.data.award)

						this.active = 0
						let timer = setInterval(() => {
							if (this.active < index + 24) {
								this.active++
							} else {
								this.lotteryLoading = false
								this.$Toast.show('恭喜，获得' + res[0].data.data.award)
								clearInterval(timer)
							}
						}, 100)
					} else {
						this.lotteryLoading = false
						this.$Toast.show('失败请刷新重试')
					}
				}
				let cancel = () => {
					this.noConfirm = true
					confirm()
				}
				if (!this.noConfirm) {
					this.$Confirm.show('本次抽奖将消耗一次机会', confirm, '确定抽奖', cancel, '不再提示')
				} else {
					confirm()
				}
			},
			showAlertAction(i) {
				this.itemData = this.awardList[i]
				this.showAlert = true
			},
			back() {
				if (this.lotteryLoading) {
					this.$Toast.show('正在抽奖')
					return
				}
				this.$router.back()
			},
			goMine() {
				if (this.lotteryLoading) {
					this.$Toast.show('正在抽奖')
					return
				}
				this.$router.push('/mine')
			},
			async goWeb(type, link) {
				if (this.lotteryLoading) {
					this.$Toast.show('正在抽奖')
					return
				}
				let res = await this.$store.dispatch('addLotteryNum', {
					type: type
				})
				if (this.$Api.ok(res)) {
					this.getLotteryLeftNum()
				}
				window.location.href = link
			}
		},
	};
</script>
<style scoped>
	.Mine {
		width: 100%;
		height: 100%;
		background: url(../assets/img/bg.png);
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
		overflow-y: scroll;
	}

	.back-btn {
		height: 30px;
		float: left;
		margin-left: 10px;
		margin-top: 60px;
		flex: 1;
	}

	.back-btn img {
		display: block;
		float: left;
		height: 100%;
		padding-right: 10px;
	}

	.back-btn span {
		display: block;
		line-height: 30px;
		height: 100%;
		font-size: 16px;
		font-weight: 600;
		color: #8d6045;
	}

	.mine-btn {
		min-width: 60px;
		height: 60px;
		float: right;
		margin-right: 10px;
		margin-top: 40px;
	}

	.flex {
		display: flex;
	}

	.title {
		width: 80%;
		display: block;
		margin: 0 auto;
	}

	.lottery-box {
		width: 100%;
	}

	.lottery-item {
		display: inline-block;
		width: 33.33%;
		height: auto;
		margin-top: 10px;
	}

	.lottery-item .name {
		text-align: center;
		position: relative;
		top: -10px;
		color: #bd8e5b;
	}

	.item {
		background: url(../assets/img/lottery/item.png);
		background-position: center center;
		background-repeat: no-repeat;
		background-size: contain;
	}

	.item-white {
		background: url(../assets/img/lottery/item-white.png);
		background-position: center center;
		background-repeat: no-repeat;
		background-size: contain;
	}

	.lottery-item img {
		display: block;
		margin: 0 auto;
		width: 60%;
		padding: 10px;
	}

	.tip {
		display: inline-block;
		width: 100%;
		text-align: center;
		color: #bd8e5b;
	}

	.title2 {
		display: inline-block;
		margin-top: 10px;
		height: 20px;
		padding-top: 4px;
		background: url(../assets/img/lottery/title2.png);
		background-position: center center;
		background-repeat: no-repeat;
		background-size: contain;
		color: #8d6045;
		font-weight: 600;
	}

	.rule-blank {
		border: 1px solid #8d6045;
		border-radius: 6px;
		background-color: rgba(228, 198, 119, 0.3);
		width: 80%;
		margin: 0 auto;
		padding: 8px;
		color: #bd8e5b;
		line-height: 20px;
	}

	.rule-title {
		color: #8D6045;
	}
</style>
